import Layout from "../components/Layout";
import Container  from 'react-bootstrap/Container';
function About() {
    return (
        <>
            <Layout>
<Container>

                About
</Container>
            </Layout>
        </>
    );
}

export default About;